export enum TemplateModuleType {
  Header = 1,
  Main = 2,
  Details = 3,
  Footer = 4
}